<template>
    <div id="recordReceiptView">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div class="right-asset-tab-list purchase-order-right-tab">
            <div id="tabs" class="containerTab mt-3 mb-3">
                <div class="tabs">
                    <a style="width:100%!important;" v-on:click="activetab=1" v-bind:class="[ activetab === 1 ? 'active' : '' ]">Receipt Details</a>
                </div>
                <div class="content">
                    <div v-show="activetab === 1" class="tabcontent">
                        <div class="list-view">
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <!-- <span class="work-order-icon"> <i class="hi-icon icon-flbill"></i> </span> -->
                                <label class="col">#Receipt:</label>
                                <span class="col">{{receipt_number}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <!-- <span class="work-order-icon"> <i class="hi-icon icon-flbill"></i> </span> -->
                                <label class="col">#PO:</label>
                                <span class="col">{{poNum}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <!-- <span class="work-order-icon"> <i class="hi-icon icon-flman-user"></i> </span> -->
                                <label class="col">Vendor:</label>
                                <span class="col">{{vendor}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <!-- <span class="work-order-icon"> <i class="hi-icon icon-fltime-saving"></i> </span> -->
                                <label class="col">Status:</label>
                                <span class="col">{{status}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <!-- <span class="work-order-icon"> <i class="hi-icon icon-flcalendar2"></i> </span> -->
                                <label class="col">Location:</label>
                                <span class="col">{{location}}</span>
                            </div>
                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <label class="col">Receive Date:</label>
                                <span class="col">{{received_datetime}}</span>
                            </div>

                            <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                <label class="col">Receive By:</label>
                                <span class="col">{{user}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="page-content-wrapper" class="admin-content-area left-asset-detail-section purchase-order-left-section">
            <template v-if="cantAccessPage === true">
                <div class="page-name asset-view-page-name purchase-order-title">
                    <div class="page-title"> Receipt Details</div>
                    <div class="workorder-action-btn btn-groups">
                        <button v-if="billCreated != 'yes'" type="submit" id="createReceiptvendorinvoice" v-on:click="vendorInvoice()" class="btn btn-primary mr-2 mb-1" >Vendor Invoice
                        </button>
                        <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                        <router-link class="btn btn-secondary pull-right" v-bind:to="{path: backPageUrl}">
                            <i class="fp-back"></i>  Back
                        </router-link>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content record-receipt-view">
                        <section class="internal-container border-top-table-fl">
                            <template v-if="receiptItemArr.length == 0">
                                <div class="lineitem-main-section">
                                    <h2>No Line Item Added</h2>
                                </div>
                            </template>
                            <template v-else>
                                <div class="table-responsive-sm">
                                    <table aria-describedby="table" id="contact_table" class="table table-sm table-bordered purchase-order-item-table" v-if="receiptItemArr != undefined && receiptItemArr.length > 0">
                                        <thead>
                                            <tr class="table-primary">
                                                <template v-if="po_type == 'misc'">
                                                    <th>Description</th>
                                                </template>
                                                <template v-else>
                                                    <th>Part</th>
                                                </template>    
                                                <th class="text-right">Qty/Hours</th>
                                                <th class="text-right">Cost</th>
                                                <th class="text-right">Line Total Cost</th>
                                                <template v-if="po_type == 'misc'">
                                                    <th>UOM</th>
                                                </template>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in receiptItemArr" v-bind:key="index">
                                                <template v-if="po_type == 'misc'">
                                                    <td> <p v-if="item.description != undefined" class="m-0">{{ item.description}}</p><p class="m-0" v-else>-</p> </td>
                                                </template>
                                                <template v-else>
                                                    <td> <p v-if="item.item" class="m-0">{{ item.item}}</p><p class="m-0" v-else>-</p> </td>
                                                </template>
                                                <td class="text-right"> {{ item.quantity}} </td>
                                                <td> <p v-if="item.cost != 0" class="m-0 text-right">{{ numberFormat(item.cost)}}</p><p class="m-0 text-right" v-else>-</p> </td>
                                                <td> <p v-if="item.line_total_cost != 0" class="m-0 text-right">{{ numberFormat(item.line_total_cost)}}</p><p class="m-0 text-right" v-else>-</p> </td>
                                                <template v-if="po_type == 'misc'">
                                                    <td> <p v-if="item.uom != undefined" class="m-0">{{ item.uom}}</p><p class="m-0" v-else>-</p> </td>
                                                </template>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </template>
                        </section>
                        <p>&nbsp;</p>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

    import Vue from "vue";

    

    import {commonMixins} from '../mixins/commonMixins';
    import ActivityLogListView from '@/components/ActivityLogList.vue';
    import EventBus from "././event-bus";
    Vue.component("estimate-activity-log-list", ActivityLogListView);
    

    export default {
        name: "recordReceiptView",
        mixins:[commonMixins],

        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            loading:false,
            poNum:"",
            vendor:"",
            location:"",
            unitPrice:0,
            taxAmount:0,
            chargesTotal:0,
            taxTotal:0,
            receipt_number:'',
            receive_datetime:"",
            receiptItemArr:[],
            activetab: 1,
            activityLogsTabValue: "vendorpoloadList",
            activityLoaded:false,
            isProcessed:0,
            backPageUrl:"/record-receipt/list",
            pageKey:"",
            received_datetime:'',
            user:'',
            status:'',
            po_type:'item',
            billCreated:'no',
            po_id:''
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'view_purchase_order_receipt') {
                            self.cantAccessPage = true;
                        }
                    }
                }

            }
        },
        created: function() {

        },

        mounted: function() {
            var self = this;

            self.getPermissions();
            self.loadRecordReceipt();

            var pathUrl = window.location.pathname;
            var segments = pathUrl.split("/");
            self.pageKey='_vendor_po_view_'+segments[3];
            self.subKey1='_vendor_po_item_view_'+segments[3];

            if (self.$route.query.fromUrl != undefined){
                self.backPageUrl = atob(self.$route.query.fromUrl);
            }

        },
        metaInfo() {
            return{
                title: (this.receipt_number != "")? this.receipt_number + " | Purchase Order Receipt View | " +process.env.COPYRIGHT_NAME:"Vendor Purchase Order View | " +process.env.COPYRIGHT_NAME
            }
        },
        methods: {

            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },

            loadRecordReceipt() {

                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");

                $.ajax({
                    url: process.env.ROOT_API + "/record-receipt/"+segments[3],
                    type: "POST",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {

                            var dataSet = data.content.data;

                            self.receipt_number = dataSet.receipt_number;
                            self.poNum = dataSet.po_no;
                            if(dataSet.vendor != null){
                                self.vendor = dataSet.vendor;
                            }else{
                                self.vendor = "-"
                            }
                            self.location = dataSet.location;

                            if(dataSet.user != null){
                                self.user = self.titleCase(dataSet.user);
                            }else{
                                self.user = "-";
                            }

                            self.status = self.titleCase(dataSet.status);
                            self.received_datetime = dataSet.receive_datetime;
                            self.po_id = dataSet.po_id;
                            self.po_type = dataSet.type;
                            if (dataSet.bill_id != undefined && dataSet.bill_id != null) {
                                self.billCreated = 'yes';
                            }else{
                                self.billCreated = 'no';
                            }
                            self.receiptItemArr = data.content.item;

                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'load-view-vendor-po')
                    }
                });
            },
            loadPurchaseOrderItem(){
                var path = window.location.pathname;
                var segments = path.split("/");
                var self = this;
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/vendor-purchase-order/items/" + segments[3],
                    type: "GET",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);

                        if (data.status == "success") {

                            self.purchaseOrderItemsArr = [];
                            if(data.content.length>=1) {
                                for (var i = 0; i < data.content.length; i++) {
                                    if (data.content[i].charge_id == null){
                                        self.purchaseOrderItemsArr.push({
                                            purchase_order_item_id: data.content[i].id,
                                            purchase_order_id: data.content[i].purchase_order_id,
                                            manufacture_id: (data.content[i].manufacture_id != undefined && data.content[i].manufacture_id != null && data.content[i].manufacture_id != '')?{value: data.content[i].manufacture_id, text: self.titleCase(data.content[i].vmCode + " | " + data.content[i].vmName)}:"-",
                                            model_id: (data.content[i].model_id != undefined && data.content[i].model_id != null && data.content[i].model_id != '')?{value: data.content[i].model_id, text: self.titleCase(data.content[i].vmodelsCode + " | " + data.content[i].vmodelsName)}:"-",
                                            part: (data.content[i].item_id != undefined && data.content[i].item_id != null && data.content[i].item_id != '')?{value: data.content[i].item_id, text: self.titleCase(data.content[i].iCode + " (" + data.content[i].iName)}:"-",
                                            description:data.content[i].description,
                                            year: (data.content[i].year != undefined && data.content[i].year != null && data.content[i].year != '')?data.content[i].year:"-",
                                            quantity: data.content[i].quantity,
                                            asset_pool_id: (data.content[i].asset_pool_id != undefined && data.content[i].asset_pool_id != null && data.content[i].asset_pool_id != '')?{value: data.content[i].item_id, text: self.titleCase(data.content[i].vpoolCode + " | " + data.content[i].vpoolDesc)}:"-",
                                            unit_price: data.content[i].unit_price,
                                            tax_percentage: data.content[i].tax_percentage,
                                            tax_amount: data.content[i].tax_amount,
                                            sub_total: data.content[i].sub_total,
                                            total: data.content[i].total,
                                            req_id: data.content[i].requisition_id,
                                        })
                                    }else{
                                        self.chargeItemArr.push({
                                            purchase_order_item_id: data.content[i].id,
                                            purchase_order_id: data.content[i].purchase_order_id,
                                            charge_id: (data.content[i].charge_id != undefined && data.content[i].charge_id != null && data.content[i].charge_id != '')?{value: data.content[i].charge_id, text: self.titleCase(data.content[i].charge_name)}:"-",
                                            quantity: data.content[i].quantity,
                                            unit_price: data.content[i].unit_price,
                                            sub_total: data.content[i].sub_total,
                                            total: data.content[i].total,
                                        })
                                    }

                                }
                            }

                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'load-view-vendor-po-item')
                    }
                });
            },
            titleCase(str) {
                if ( str == null ) {
                    return "-";
                } else {
                    var value = str.toString();
                    return value.charAt(0).toUpperCase() + value.slice(1);
                }
            },
            activityLogs(){

                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");

                self.$root.$emit('activity_log_opted','purchase order',segments[3]);
//                self.activityLogsTabValue = "loadList";     // flag value set to loadList so that filters in list work properly.
                self.activetab = 2;
            },
            vendorInvoice:function(){
                var self = this;

                var path = window.location.pathname;
                var segments = path.split("/");

                var url = '&id=' + self.po_id +'&receipt_id=' + segments[3] + '&type=' + self.po_type+'&redirectFrom=receiptview';
                self.$router.push({ name: 'BillCreate', query: { data : btoa(url) }});
            }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/RecordReceiptView.vue